//# sourceMappingURL=use-font.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/fonts/use-font.interface.js
// module id = 1171
// module chunks = 4